import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { DialogNames, QuoteStatuses } from '../constants';
import { Dispatch, iRootState } from '../redux/store';
import useFormatMessage from '../useFormatMessage';
import useOpenCurrencyPayWindowToPayTotal from '../useOpenCurrencyPayWindowToPayTotal';
import useIsPayNowEnabled from './useIsPayNowEnabled';

const FeedbackConfirmationDialog = function FeedbackConfirmationDialog(): React.ReactElement {
  const openDialog = useSelector(
    (state: iRootState) => state.dialog.openDialog
  );
  const status = useSelector((state: iRootState) => state.quote.status);
  const quoteId = useSelector((state: iRootState) => state.quote.id);
  const hasTerms = useSelector(
    (state: iRootState) => state.paymentTerms.terms.length > 0
  );

  const statusAccepted = useFormatMessage({
    id: 'accepted',
    defaultMessage: 'Accepted'
  });
  const statusDeclined = useFormatMessage({
    id: 'declined',
    defaultMessage: 'Declined'
  });
  const statusChangesRequested = useFormatMessage({
    id: 'changesRequested',
    defaultMessage: 'Changes Requested'
  });

  function getStatusDescription() {
    switch (status) {
      case QuoteStatuses.Accepted:
        return statusAccepted;
      case QuoteStatuses.Declined:
        return statusDeclined;
      case QuoteStatuses.ChangesRequested:
        return statusChangesRequested;
      default:
        return status;
    }
  }

  function getContentMessageId() {
    switch (status) {
      case QuoteStatuses.ChangesRequested:
        return 'thequotehasbeenchangesrequestedandthesenderhasbeennotified';
      default:
        return 'thequotehasbeenstatusandthesenderhasbeennotified';
    }
  }

  function getContentDefaultMessage() {
    switch (status) {
      case QuoteStatuses.ChangesRequested:
        return 'The quote has {statusDescription} and the sender has been notified.';
      default:
        return 'The quote has been {statusDescription} and the sender has been notified.';
    }
  }

  const statusDescription = getStatusDescription();
  const contentMessageId = getContentMessageId();
  const contentDefaultMessage = getContentDefaultMessage();

  const open = openDialog === DialogNames.FeedbackConfirmed;
  const dispatch = useDispatch<Dispatch>();
  const { push } = useHistory();
  const { openCurrencyPayWindow } = useOpenCurrencyPayWindowToPayTotal();
  const isPayNowEnabled = useIsPayNowEnabled();

  const onOKClick = function handleOnOKClick(): void {
    dispatch.dialog.setOpenDialog('');

    if (status === QuoteStatuses.Accepted) {
      const anchor = document.querySelector('#back-to-bottom-anchor');
      const redirect = isPayNowEnabled && hasTerms;
      const launchWidget = isPayNowEnabled && !hasTerms;
      if (launchWidget) {
        openCurrencyPayWindow();
      } else if (redirect) {
        push(`/quote/${quoteId}/payment`);
      } else if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  };

  const onClose = function handleOnClose(): void {
    dispatch.dialog.setOpenDialog('');
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{statusDescription}</DialogTitle>
      <DialogContent>
        <FormattedMessage
          id={contentMessageId}
          defaultMessage={contentDefaultMessage}
          values={{ statusDescription }}
        />
      </DialogContent>
      <DialogActions>
        <Button color='primary' variant='outlined' onClick={onOKClick}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackConfirmationDialog;
